import { type RefSelectProps, Select } from 'antd'
import clsx from 'clsx'
import { forwardRef, type Ref } from 'react'

import { type SingleOrMultipleSelectProps } from '@/components/types'
import { STATUSES } from '@/constants/common/message.constants'
import { SIGHT_MONTH_OFFSET, SIGHT_MONTH_OFFSET_LABEL } from '@/libs/api/types'
import { type SightMonthOffset } from '@/libs/api/types'
import { useSelectOnChangeHandler } from '@/libs/hooks'

type Props = SingleOrMultipleSelectProps<
  SightMonthOffset,
  SightMonthOffsetOption
>

type SightMonthOffsetOption = { label: string; value: SightMonthOffset }

const options: SightMonthOffsetOption[] = Object.values(SIGHT_MONTH_OFFSET).map(
  (sight) => ({
    label: SIGHT_MONTH_OFFSET_LABEL[sight],
    value: sight
  })
)

/**
 * 銀行口座種別を選択するSelect
 */
export const SightMonthOffsetSelect = forwardRef(
  (
    {
      className,
      placeholder = STATUSES.UNSELECTED,
      value,
      mode,
      onChange,
      ...props
    }: Props,
    ref: Ref<RefSelectProps> | undefined
  ) => {
    const handleChange = useSelectOnChangeHandler({ mode, onChange })
    return (
      <Select
        ref={ref}
        {...props}
        mode={mode}
        value={value}
        onChange={handleChange}
        className={clsx(['min-w-[140px]', className])}
        options={options}
        placeholder={placeholder}
      />
    )
  }
)
